import React from 'react';
import PropTypes from 'prop-types';
import {
    TAG_CLASS,
    TAG_CLOSE_CLASS,
    TAG_CLOSE_TESTID,
} from './constants';
import './_tag.scss';

const Tag = ({children, closable, onClose}) => {
    return (
        <span className={TAG_CLASS}>
            {children}
            {closable && <span data-testid={TAG_CLOSE_TESTID} className={TAG_CLOSE_CLASS} onClick={onClose} />}
        </span>
    );
};

Tag.propTypes = {
    children: PropTypes.string.isRequired,
    closable: PropTypes.bool,
    onClose: PropTypes.func,
};

Tag.defaultProps = {
    closable: true,
    onClose: Function.prototype,
};

export default Tag;
